import React, { Component } from "react";
/*eslint-disable no-unused-vars*/
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
/*eslint-enable no-unused-vars*/
import ReturnNavBar from "../components/returnBar";
import SignIn from "./sign_in";
import SignUp from "./sign_up";
import CreateQuestion from "./createQuestion";
import Question from "./question";
import CategoryPage from "./category";
import UserProfilePage from "./user_profile";
import UserFollowing from "./user_following";
import UserFollowers from "./user_followers";
import Recommendation from "./recommendation";
import HashtagPage from "./hashtag";
import ListQuestions from "./listQuestions";
import ForgetPassword from "./forget_password";
import Invite from "./invite";
import UserLikes from "./user_likes";
import UserBookmark from "./user_bookmarks";
import List from "./list";
import Search from "./search";

class PushedView extends Component {
  render() {
    return (
      <React.Fragment>
        {this.returnGoodNavBar()}
        <Switch>
          <Route exact path="/sign_in" component={SignIn} />
          <Route exact path="/sign_up" component={SignUp} />
          <Route exact path="/forget_password" component={ForgetPassword} />
          <Route exact path="/create" component={CreateQuestion} />
          <Route exact path="/question" component={ListQuestions} />
          <Route path="/question/:id" component={Question} />
          <Route path="/search" component={Search} />
          <Route exact path="/users/:id" component={UserProfilePage} />
          <Route path="/users/:id/followers" component={UserFollowers} />
          <Route path="/users/:id/following" component={UserFollowing} />
          <Route
            path="/users/:id/hashtag/:hashtag_name"
            component={HashtagPage}
          />
          <Route path="/users/:id/likes" component={UserLikes} />
          <Route path="/hashtag/:hashtag_name" component={HashtagPage} />
          <Route path="/category/:id" component={CategoryPage} />
          <Route path="/recommendations/:id" component={Recommendation} />
          <Route path="/invite/:id" component={Invite} />
          <Route path="/list/:id" component={List} />

          <Route path="/profile/bookmarks" component={UserBookmark} />
        </Switch>
      </React.Fragment>
    );
  }

  returnGoodNavBar() {
    if (
      this.props.match.path === "/category/:id" ||
      this.props.match.path === "/users/:id" ||
      this.props.match.path === "/create" ||
      this.props.match.path === "/hashtag/:id" ||
      this.props.match.path === "/invite/:id"
    ) {
      return <ReturnNavBar link="/" />;
    }
    if (this.props.match.path === "/recommendations/:id") {
      return <div />;
    }
    if (this.props.match.path === "/list/:id") {
      return <ReturnNavBar link="/" logo={true} />;
    }
    if (this.props.match.path === "/question/:id") {
      return <ReturnNavBar link="/question" />;
    }
    return <ReturnNavBar link="/profile" />;
  }
}

export default PushedView;



// WEBPACK FOOTER //
// ./src/pages/pushed_view.jsx